<div class="contactPage">
    <div class="anonymousLogo" *ngIf="!authService.isLoggedIn()">
        <a routerLink="/login">
            <img src="assets/Lionsgate-Repertory-logo.png" alt="">
        </a>
    </div>
    <div class="headerBg"></div>

    <div class="content">
        <div class="title">
            <div class="label">Contact</div>
        </div>
        <div class="line"></div>

        <div class="teamItem" *ngFor="let item of data">
            <div class="teamItemTitle" [innerHTML]="item.title"></div>
            <div class="teamItemName" [innerHTML]="item.name"></div>
            
            <div class="list">
                <div class="contact" *ngFor="let contact of item.items">
                    <div class="contactName" [innerHTML]="contact.name"></div>
                    <div class="contactTitle">{{contact.title}}</div>
                    <div class="contactTitle">Email: 
                        <a [href]="'mailto:' + contact.email" target="_blank">{{contact.email}}</a>
                    </div>
                </div>
            </div>
            <div class="line" *ngIf="item.line"></div>
        </div>
    </div>

</div>